import { Link } from "react-router-dom";
import { Radar, Settings, Ship } from "lucide-react";
import AlertsBell from "@/components/AlertsBell";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const STATUS = {
  green: { color: "#10B981", label: "Ingesting" },
  amber: { color: "#F59E0B", label: "Stale feed" },
  red: { color: "#EF4444", label: "Disconnected" },
};

export const TopBar = ({ health, vesselCount, alerts, onAlertClick }) => {
  const s = STATUS[health?.status || "red"];
  return (
    <header
      data-testid="app-top-bar"
      className="absolute top-0 left-0 right-0 z-30 h-14 bg-slate-900/90 backdrop-blur-md border-b border-slate-800 px-4 flex items-center justify-between"
    >
      <div className="flex items-center gap-3">
        <div className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-cyan-500/15 border border-cyan-500/40">
          <Radar className="h-5 w-5 text-cyan-400" strokeWidth={2} />
        </div>
        <div className="leading-tight">
          <h1 className="font-display text-lg font-bold tracking-tight text-slate-100">
            Slick<span className="text-cyan-400">Trace</span>
          </h1>
          <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 -mt-0.5">
            Maritime Monitoring · Phase 1
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div
          data-testid="live-vessel-count"
          className="flex items-center gap-2 rounded-lg bg-slate-800/60 border border-slate-700/60 px-3 py-1.5"
        >
          <Ship className="h-4 w-4 text-cyan-400" />
          <span className="font-mono text-sm font-semibold text-white tabular-nums">
            {vesselCount ?? "—"}
          </span>
          <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
            vessels
          </span>
        </div>

        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                data-testid="worker-status-dot"
                className="flex items-center gap-2 rounded-lg bg-slate-800/60 border border-slate-700/60 px-3 py-1.5 cursor-default"
              >
                <span className="relative flex h-2.5 w-2.5">
                  <span
                    className="st-ping absolute inline-flex h-full w-full rounded-full"
                    style={{ color: s.color }}
                  />
                  <span
                    className="relative inline-flex h-2.5 w-2.5 rounded-full"
                    style={{ backgroundColor: s.color }}
                  />
                </span>
                <span className="text-[11px] font-mono uppercase tracking-wider text-slate-300 hidden sm:inline">
                  {s.label}
                </span>
              </div>
            </TooltipTrigger>
            <TooltipContent className="font-mono text-xs">
              <div>Provider: {health?.provider || "—"}</div>
              <div>Msgs/min: {health?.messages_per_min ?? 0}</div>
              <div>DB positions: {health?.db?.positions ?? 0}</div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <AlertsBell alerts={alerts} onAlertClick={onAlertClick} />

        <Link
          to="/settings"
          data-testid="settings-link"
          className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800/60 border border-slate-700/60 text-slate-300 hover:text-cyan-400 hover:border-cyan-500/40 transition-colors"
        >
          <Settings className="h-4.5 w-4.5" />
        </Link>
      </div>
    </header>
  );
};

export default TopBar;
